import type { Place, PlacesState } from '../types/places-types';

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api, { endpoints } from 'src/lib/axios';

const initialState: PlacesState = {
  places: [],
  loading: false,
  error: null,
};

export const fetchPlaces = createAsyncThunk(
  'places/fetchPlaces',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(endpoints.admin.places);
      return response.data.places as Place[];
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error occurred');
    }
  }
);

export const deletePlace = createAsyncThunk<string, string>(
  'places/deletePlace',
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`${endpoints.admin.places}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Unknown error occurred');
    }
  }
);

const placesSlice = createSlice({
  name: 'places',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlaces.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPlaces.fulfilled, (state, action) => {
        state.loading = false;
        state.places = action.payload;
        state.error = null;
      })
      .addCase(fetchPlaces.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(deletePlace.fulfilled, (state, action) => {
        state.places = state.places.filter((place) => place.id !== action.payload);
        state.error = null;
      })
      .addCase(deletePlace.rejected, (state, action) => {
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = placesSlice.actions;
export default placesSlice.reducer;
